import { render } from "./ParametrosGenerales.vue?vue&type=template&id=4fa71084"
import script from "./ParametrosGenerales.vue?vue&type=script&lang=js"
export * from "./ParametrosGenerales.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__